export const colors = {
  red: "#D71881",
  background: "#fff",
  copy: "#222222",
};
